/**
 * Created-on line for workspace overview: "Jun 19 · 2025" (locale-aware month).
 *
 * @param {string | null | undefined} dateString
 * @param {string} [locale] i18n language (e.g. "en", "es")
 * @returns {string}
 */
export const formatOverviewCreatedAt = (dateString, locale = 'en') => {
  if (!dateString) return '—';
  try {
    const d = new Date(dateString);
    if (Number.isNaN(d.getTime())) return '—';
    const month = d.toLocaleDateString(locale, { month: 'short' });
    const day = d.getDate();
    const year = d.getFullYear();
    return `${month} ${day} · ${year}`;
  } catch {
    return '—';
  }
};
